import { instanceOf } from 'prop-types'
import cn from 'classnames'

import localizedPostTime from '../../../../utilities/localizedPostTime.js'
import UserProfileImage from '../../theme-components/user-profile-image.js'
import Post from '../../../../../models/Post.js'
import Settings from '../../../../../models/settings.js'

export default function CardHeader({ post, settings }) {
  if (settings.isCenteredTheme) {
    return null
  }

  return (
    <div
      aria-hidden="true"
      className={cn('bzfy-o-header', {
        'bzfy-o-header--center': settings.postHeaderCentered,
      })}
    >
      {settings.showProfileImage && (
        <div className="bzfy-o-header__image-container">
          <UserProfileImage
            className="bzfy-o-header__image"
            profileImageUrl={post.profileImageUrl}
            source={post.sourceName}
          />
        </div>
      )}
      {settings.displayName && post.userName && (
        <div className="bzfy-o-header__user">{post.userName}</div>
      )}
      {settings.postAge && (
        <div className="bzfy-o-header__time">{localizedPostTime(post, settings.locale)}</div>
      )}
    </div>
  )
}

CardHeader.propTypes = {
  post: instanceOf(Post).isRequired,
  settings: instanceOf(Settings).isRequired,
}
